import React from 'react';
import { PrimaryCTA, Eyebrow, TrustSignals } from './Shared';
export function Hero() {
  return <section className="hero" data-id="element-48">
      <Eyebrow data-id="element-49">Antes de una decisión de $4,000 – $15,000</Eyebrow>

      <h1 className="hero-h1" data-id="element-50">
        Antes de decidir sobre tu cuerpo,
        <br data-id="element-51" />
        <span className="hero-accent" data-id="element-52">hazlo con más claridad.</span>
      </h1>

      <p className="hero-sub" data-id="element-53">
        A.R.M.O.N.Y. es el bundle de preparación creado por Dermaclinic. Cuatro
        recursos diseñados para que llegues a tu valoración con criterio, calma
        y las preguntas correctas — antes de elegir clínica, antes de apartar
        fecha, antes de firmar.
      </p>

      <div className="hero-cta-stack" data-id="element-54">
        <PrimaryCTA ctaId="hero" data-id="element-55" />
        <span className="hero-microcopy" data-id="element-56">
          Te toma ~90 minutos. Léelo antes de tu valoración.
        </span>
        <TrustSignals data-id="element-57" />
      </div>
    </section>;
}